import {EntityState} from "@ngrx/entity";
import {FileMessageNotSended} from "../../../../domain/FileMessageNotSended";
import {adapterFileMessageNotSended} from "../../adapters/filemessagenotsended.adapters";


export interface IFileMessageNotSendedState extends EntityState<FileMessageNotSended> {}
export const initialFileMessageNotSendedState : IFileMessageNotSendedState = adapterFileMessageNotSended.getInitialState(undefined);
